/**
 * @generated SignedSource<<d11d7e091f62aa876c5ab06e4fc8493e>>
 * @relayHash 8443cf09df7957161eeedf507a1a55d6
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8443cf09df7957161eeedf507a1a55d6

import { ConcreteRequest } from 'relay-runtime';
export type BetterDoc = "ALLOWED" | "CONDITION_PACKAGE" | "NOT_ALLOWED" | "REQUIRED";
export type Country = "CH" | "DE";
export type Gatekeeper = "GENERAL_PRACTITIONER" | "MEDGATE_AND_OTHERS" | "MEDGATE_ONLY" | "NOT_MEDGATE" | "NO_GATEKEEPER";
export type InsurerGroup = "GROUPE_MUTUEL" | "RVK";
export type Law = "IVG" | "KVG" | "MVG" | "ORG" | "UVG" | "VVG";
export type Payment = "FLAT_RATE_B2B" | "HYBRID_B2B" | "TARMED_B2B" | "TARMED_B2C";
export type ProductCode = "B2C" | "DEM" | "FLX" | "ITC" | "MCS" | "TGP";
export type ReferralToGeneralPractitioner = "INSURANCE_LIST" | "MPN" | "NONE";
export type ReferralToSpecialist = "INSURANCE_LIST" | "MPN" | "NONE";
export type SortEnumType = "ASC" | "DESC";
export type TeleConsultation = "ALLOWED" | "NOT_ALLOWED" | "REQUIRED";
export type TimeWindow = "NOT_REQUIRED" | "REQUIRED";
export type OrganisationSortInput = {
  address?: AddressSortInput | null;
  canton?: SortEnumType | null;
  country?: SortEnumType | null;
  defaultCompulsoryProduct?: ProductSortInput | null;
  defaultCompulsoryProductId?: SortEnumType | null;
  defaultSupplementaryProduct?: ProductSortInput | null;
  defaultSupplementaryProductId?: SortEnumType | null;
  globalLocationNumber?: SortEnumType | null;
  id?: SortEnumType | null;
  insurerGroup?: SortEnumType | null;
  key?: SortEnumType | null;
  lawType?: SortEnumType | null;
  name?: SortEnumType | null;
  nationalInsuranceNumber?: SortEnumType | null;
};
export type AddressSortInput = {
  city?: SortEnumType | null;
  countryCode?: SortEnumType | null;
  houseNumberStreet?: SortEnumType | null;
  postalCode?: SortEnumType | null;
};
export type ProductSortInput = {
  displayId?: SortEnumType | null;
  id?: SortEnumType | null;
  isPrimary?: SortEnumType | null;
  key?: SortEnumType | null;
  name?: SortEnumType | null;
  organisation?: OrganisationSortInput | null;
  organisationId?: SortEnumType | null;
};
export type OrganisationFilterInput = {
  address?: AddressFilterInput | null;
  and?: ReadonlyArray<OrganisationFilterInput> | null;
  canton?: StringOperationFilterInput | null;
  country?: CountryOperationFilterInput | null;
  defaultCompulsoryProduct?: ProductFilterInput | null;
  defaultCompulsoryProductId?: IdOperationFilterInput | null;
  defaultSupplementaryProduct?: ProductFilterInput | null;
  defaultSupplementaryProductId?: IdOperationFilterInput | null;
  globalLocationNumber?: StringOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  insurerGroup?: NullableOfInsurerGroupOperationFilterInput | null;
  key?: StringOperationFilterInput | null;
  lawType?: NullableOfLawOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  nationalInsuranceNumber?: IntOperationFilterInput | null;
  or?: ReadonlyArray<OrganisationFilterInput> | null;
  products?: ListFilterInputTypeOfProductFilterInput | null;
};
export type AddressFilterInput = {
  and?: ReadonlyArray<AddressFilterInput> | null;
  city?: StringOperationFilterInput | null;
  countryCode?: StringOperationFilterInput | null;
  houseNumberStreet?: StringOperationFilterInput | null;
  or?: ReadonlyArray<AddressFilterInput> | null;
  postalCode?: StringOperationFilterInput | null;
};
export type StringOperationFilterInput = {
  and?: ReadonlyArray<StringOperationFilterInput> | null;
  contains?: string | null;
  endsWith?: string | null;
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  ncontains?: string | null;
  nendsWith?: string | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nstartsWith?: string | null;
  or?: ReadonlyArray<StringOperationFilterInput> | null;
  startsWith?: string | null;
};
export type CountryOperationFilterInput = {
  eq?: Country | null;
  in?: ReadonlyArray<Country> | null;
  neq?: Country | null;
  nin?: ReadonlyArray<Country> | null;
};
export type ProductFilterInput = {
  and?: ReadonlyArray<ProductFilterInput> | null;
  coverages?: ListFilterInputTypeOfCoverageFilterInput | null;
  displayId?: IntOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  isPrimary?: BooleanOperationFilterInput | null;
  key?: StringOperationFilterInput | null;
  name?: StringOperationFilterInput | null;
  or?: ReadonlyArray<ProductFilterInput> | null;
  organisation?: OrganisationFilterInput | null;
  organisationId?: IntOperationFilterInput | null;
  productConfigurations?: ListFilterInputTypeOfProductConfigurationFilterInput | null;
};
export type ListFilterInputTypeOfCoverageFilterInput = {
  all?: CoverageFilterInput | null;
  any?: boolean | null;
  none?: CoverageFilterInput | null;
  some?: CoverageFilterInput | null;
};
export type CoverageFilterInput = {
  and?: ReadonlyArray<CoverageFilterInput> | null;
  createdAt?: DateTimeOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  insuree?: InsureeFilterInput | null;
  insureeId?: IdOperationFilterInput | null;
  or?: ReadonlyArray<CoverageFilterInput> | null;
  policyNumber?: StringOperationFilterInput | null;
  product?: ProductFilterInput | null;
  productId?: IdOperationFilterInput | null;
  updatedAt?: DateTimeOperationFilterInput | null;
  validFrom?: DateOperationFilterInput | null;
  validTo?: DateOperationFilterInput | null;
};
export type DateTimeOperationFilterInput = {
  eq?: string | null;
  gt?: string | null;
  gte?: string | null;
  in?: ReadonlyArray<string | null> | null;
  lt?: string | null;
  lte?: string | null;
  neq?: string | null;
  ngt?: string | null;
  ngte?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nlt?: string | null;
  nlte?: string | null;
};
export type IdOperationFilterInput = {
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
};
export type InsureeFilterInput = {
  and?: ReadonlyArray<InsureeFilterInput> | null;
  coverages?: ListFilterInputTypeOfCoverageFilterInput | null;
  createdAt?: DateTimeOperationFilterInput | null;
  healthInsuranceCardNumber?: StringOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  insureeNumber?: StringOperationFilterInput | null;
  or?: ReadonlyArray<InsureeFilterInput> | null;
  organisation?: OrganisationFilterInput | null;
  organisationId?: IdOperationFilterInput | null;
  patientId?: IdOperationFilterInput | null;
};
export type DateOperationFilterInput = {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: ReadonlyArray<any | null> | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: ReadonlyArray<any | null> | null;
  nlt?: any | null;
  nlte?: any | null;
};
export type IntOperationFilterInput = {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: ReadonlyArray<number | null> | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: ReadonlyArray<number | null> | null;
  nlt?: number | null;
  nlte?: number | null;
};
export type BooleanOperationFilterInput = {
  eq?: boolean | null;
  neq?: boolean | null;
};
export type ListFilterInputTypeOfProductConfigurationFilterInput = {
  all?: ProductConfigurationFilterInput | null;
  any?: boolean | null;
  none?: ProductConfigurationFilterInput | null;
  some?: ProductConfigurationFilterInput | null;
};
export type ProductConfigurationFilterInput = {
  allowManualCoverage?: BooleanOperationFilterInput | null;
  allowSearchCoverage?: BooleanOperationFilterInput | null;
  and?: ReadonlyArray<ProductConfigurationFilterInput> | null;
  assistancePhoneNumber?: StringOperationFilterInput | null;
  betterDoc?: BetterDocOperationFilterInput | null;
  betterDocKey?: StringOperationFilterInput | null;
  billingLabelKeys?: ListStringOperationFilterInput | null;
  carePlan?: BooleanOperationFilterInput | null;
  certificateOfIncapacity?: BooleanOperationFilterInput | null;
  conditionPackageKey?: StringOperationFilterInput | null;
  displayId?: IntOperationFilterInput | null;
  externalAssistance?: StringOperationFilterInput | null;
  gatekeeper?: NullableOfGatekeeperOperationFilterInput | null;
  genericsObligation?: BooleanOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  importCodes?: ListStringOperationFilterInput | null;
  infoLink?: StringOperationFilterInput | null;
  infoLinkEn?: StringOperationFilterInput | null;
  infoPackageLink?: StringOperationFilterInput | null;
  isEligibleToPartnerPortal?: BooleanOperationFilterInput | null;
  isMedgateTeleGeneralPractitioner?: BooleanOperationFilterInput | null;
  isMedicalChatEnabled?: BooleanOperationFilterInput | null;
  isPrimary?: BooleanOperationFilterInput | null;
  lateEmergencyRegistrationDuration?: IntOperationFilterInput | null;
  nursingRate?: BooleanOperationFilterInput | null;
  or?: ReadonlyArray<ProductConfigurationFilterInput> | null;
  packageFirstContact?: BooleanOperationFilterInput | null;
  packageLateRegistration?: BooleanOperationFilterInput | null;
  packageSelfReferral?: BooleanOperationFilterInput | null;
  payment?: PaymentOperationFilterInput | null;
  phoneNumber?: StringOperationFilterInput | null;
  prescription?: BooleanOperationFilterInput | null;
  product?: ProductFilterInput | null;
  productCode?: NullableOfProductCodeOperationFilterInput | null;
  productId?: IntOperationFilterInput | null;
  referral?: BooleanOperationFilterInput | null;
  referralToGeneralPractitioner?: ReferralToGeneralPractitionerOperationFilterInput | null;
  referralToGeneralPractitionerInsuranceListId?: IntOperationFilterInput | null;
  referralToSpecialist?: ReferralToSpecialistOperationFilterInput | null;
  referralToSpecialistInsuranceListId?: IntOperationFilterInput | null;
  sendWelcomeLetter?: BooleanOperationFilterInput | null;
  shouldContainInsuranceCardNumber?: BooleanOperationFilterInput | null;
  specialistBookingFlatFee?: BooleanOperationFilterInput | null;
  teleConsultation?: TeleConsultationOperationFilterInput | null;
  therapyPrescription?: BooleanOperationFilterInput | null;
  timeWindow?: TimeWindowOperationFilterInput | null;
  treatmentPlanAddition?: ProductConfigurationTreatmentPlanAdditionFilterInput | null;
  validFrom?: DateOperationFilterInput | null;
  validTo?: DateOperationFilterInput | null;
};
export type BetterDocOperationFilterInput = {
  eq?: BetterDoc | null;
  in?: ReadonlyArray<BetterDoc> | null;
  neq?: BetterDoc | null;
  nin?: ReadonlyArray<BetterDoc> | null;
};
export type ListStringOperationFilterInput = {
  all?: StringOperationFilterInput | null;
  any?: boolean | null;
  none?: StringOperationFilterInput | null;
  some?: StringOperationFilterInput | null;
};
export type NullableOfGatekeeperOperationFilterInput = {
  eq?: Gatekeeper | null;
  in?: ReadonlyArray<Gatekeeper | null> | null;
  neq?: Gatekeeper | null;
  nin?: ReadonlyArray<Gatekeeper | null> | null;
};
export type PaymentOperationFilterInput = {
  eq?: Payment | null;
  in?: ReadonlyArray<Payment> | null;
  neq?: Payment | null;
  nin?: ReadonlyArray<Payment> | null;
};
export type NullableOfProductCodeOperationFilterInput = {
  eq?: ProductCode | null;
  in?: ReadonlyArray<ProductCode | null> | null;
  neq?: ProductCode | null;
  nin?: ReadonlyArray<ProductCode | null> | null;
};
export type ReferralToGeneralPractitionerOperationFilterInput = {
  eq?: ReferralToGeneralPractitioner | null;
  in?: ReadonlyArray<ReferralToGeneralPractitioner> | null;
  neq?: ReferralToGeneralPractitioner | null;
  nin?: ReadonlyArray<ReferralToGeneralPractitioner> | null;
};
export type ReferralToSpecialistOperationFilterInput = {
  eq?: ReferralToSpecialist | null;
  in?: ReadonlyArray<ReferralToSpecialist> | null;
  neq?: ReferralToSpecialist | null;
  nin?: ReadonlyArray<ReferralToSpecialist> | null;
};
export type TeleConsultationOperationFilterInput = {
  eq?: TeleConsultation | null;
  in?: ReadonlyArray<TeleConsultation> | null;
  neq?: TeleConsultation | null;
  nin?: ReadonlyArray<TeleConsultation> | null;
};
export type TimeWindowOperationFilterInput = {
  eq?: TimeWindow | null;
  in?: ReadonlyArray<TimeWindow> | null;
  neq?: TimeWindow | null;
  nin?: ReadonlyArray<TimeWindow> | null;
};
export type ProductConfigurationTreatmentPlanAdditionFilterInput = {
  and?: ReadonlyArray<ProductConfigurationTreatmentPlanAdditionFilterInput> | null;
  english?: StringOperationFilterInput | null;
  french?: StringOperationFilterInput | null;
  german?: StringOperationFilterInput | null;
  italian?: StringOperationFilterInput | null;
  or?: ReadonlyArray<ProductConfigurationTreatmentPlanAdditionFilterInput> | null;
};
export type NullableOfInsurerGroupOperationFilterInput = {
  eq?: InsurerGroup | null;
  in?: ReadonlyArray<InsurerGroup | null> | null;
  neq?: InsurerGroup | null;
  nin?: ReadonlyArray<InsurerGroup | null> | null;
};
export type NullableOfLawOperationFilterInput = {
  eq?: Law | null;
  in?: ReadonlyArray<Law | null> | null;
  neq?: Law | null;
  nin?: ReadonlyArray<Law | null> | null;
};
export type ListFilterInputTypeOfProductFilterInput = {
  all?: ProductFilterInput | null;
  any?: boolean | null;
  none?: ProductFilterInput | null;
  some?: ProductFilterInput | null;
};
export type chConcludeBillingSectionQuery$variables = {
  order?: ReadonlyArray<OrganisationSortInput> | null;
  where?: OrganisationFilterInput | null;
};
export type chConcludeBillingSectionQuery$data = {
  readonly ch_organisations: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }>;
};
export type chConcludeBillingSectionQuery = {
  response: chConcludeBillingSectionQuery$data;
  variables: chConcludeBillingSectionQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "order",
        "variableName": "order"
      },
      {
        "kind": "Variable",
        "name": "where",
        "variableName": "where"
      }
    ],
    "concreteType": "ch_Organisation",
    "kind": "LinkedField",
    "name": "ch_organisations",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "chConcludeBillingSectionQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "chConcludeBillingSectionQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "8443cf09df7957161eeedf507a1a55d6",
    "metadata": {},
    "name": "chConcludeBillingSectionQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f4cd6f833dba2811185366acb4132984";

export default node;
